import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  cardRoot: {
    cursor: "pointer",
  },
  checkIcon: {
    color: "#C2C2C2",
  },
  email: {
    fontSize: "12px",
  },
  avatarText: {
    fontSize: "12px",
  },
  avatar: {},
});
